import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Button, CircularProgress } from "@mui/material";
import { UserResult, UserResultsResponse } from "models/Models";
import UserService from "services/UserService";
import "./Home.scss";

export const Home = () => {
  const [standings, setStandings] = useState<UserResult[]>([]);
  const [year, setYear] = useState<number>();
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const user = UserService.getUserInfo();

  useEffect(() => {
    axios.get<UserResultsResponse>(`${process.env.REACT_APP_API_URL}/user/results/all`).then((r) => {
      const sorted = [...r.data.results].sort((a, b) => {
        const totalDiff = (b.total ?? 0) - (a.total ?? 0);
        if (totalDiff !== 0) return totalDiff;
        return (b.pickPercent ?? 0) - (a.pickPercent ?? 0);
      });
      setStandings(sorted);
      setYear(r.data.year);
      setIsLoading(false);
    });
  }, []);

  return (
    <div className="home-page">
      <h2 className="welcome">Welcome back, {user?.teamName}!</h2>

      <div className="standings-section">
        <div className="standings-header">
          <h3>Current Standings</h3>
          {year && <span className="year-badge">{year}</span>}
        </div>

        {isLoading ? (
          <CircularProgress className="spinner" />
        ) : standings.every((s) => !s.total) ? (
          <p className="no-scores">No scores yet — check back once the first series wraps up.</p>
        ) : (
          <table className="standings-table">
            <thead>
              <tr>
                <th>#</th>
                <th className="team-col">Team</th>
                <th>R1</th>
                <th>R2</th>
                <th>R3</th>
                <th>Cup Final</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {standings.map((s, i) => {
                const isMe = s.teamName === user?.teamName;
                return (
                  <tr key={s.userId} className={isMe ? "my-row" : ""}>
                    <td>{i + 1}</td>
                    <td className="team-col">{s.teamName}</td>
                    <td>{s.firstRoundPoints ?? "-"}</td>
                    <td>{s.secondRoundPoints ?? "-"}</td>
                    <td>{s.thirdRoundPoints ?? "-"}</td>
                    <td>{s.finalRoundPoints ?? "-"}</td>
                    <td className="total-col">{s.total ?? "-"}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>

      <div className="action-buttons">
        <Button variant="contained" onClick={() => navigate("/picks")}>
          My Picks
        </Button>
        <Button variant="outlined" onClick={() => navigate("/picks/all")}>
          View All Picks
        </Button>
      </div>
    </div>
  );
};
